import {useAuthInfo, WithLoggedInAuthInfoProps} from "@propelauth/react";

import {CompanyType} from "../../models/company";
import {useForm} from "react-hook-form";
import {useParams} from "react-router-dom";
import React, {useContext, useState} from "react";
import {useToast} from "../ui/use-toast";
import {FullScopeModel} from "./ScopeModel";
import {Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage} from "../ui/form";
import {Card, CardContent, CardHeader, CardTitle} from "../ui/card";
import {Input} from "../ui/input";
import {Button} from "../ui/button";
import InviteBidderByEmail from "../directory/InviteByEmail";
import {EdtSaveButtonToggle} from "../ui/EdtSaveButtonToggle";
import {ProjectContext} from "../../contexts/ProjectContext";


type ScopeFormProps = {
    editable?: boolean;
    create?: boolean;
    scope: FullScopeModel;
    editing?: boolean;
    onSave: (data: FullScopeModel) => void;
    //setIsEditing: (v: boolean) => void;
    onSubmit: (data: FullScopeModel) => void;
    onCreateBid?: () => void;
    onInvite?: () => void;
    canInvite?: boolean;
    onCancel?: () => void;
};

export function ScopeForm(
    {
        create,
        editable,
        scope,
        onSave,
        canInvite,
        onSubmit,
        onCreateBid,
        onInvite,
        editing,
        onCancel,
        ...props
    }: ScopeFormProps) {
    const {accessToken} = useAuthInfo();
    // const {project_id, scope_id} = useParams<string>();
    const projectContext = useContext(ProjectContext);
    const {toast} = useToast();
    const [isEditing, setIsEditing] = useState<boolean>(editing as boolean);
    const canEdit = projectContext?.role === CompanyType.developer

    const form = useForm<FullScopeModel>({
        defaultValues: scope
    });

    return <Form {...form}>
        <form
            onSubmit={(e) => {
                e.preventDefault();
                form.handleSubmit(onSave);
            }}
        >
            <CardHeader>
                <CardTitle className="columns-2 flex justify-between">
                    <div>
                        Scope
                    </div>
                    {projectContext?.role === CompanyType.builder ?
                        <div><Button variant="outline" onClick={(e) => {
                            if (onCreateBid) {
                                onCreateBid()
                            }
                        }
                        }>

                            New Bid
                        </Button></div>
                        :
                        <div>
                            {canInvite? <InviteBidderByEmail/> : <></>}
                            {isEditing ? (
                                <div>
                                    <Button
                                        variant="outline"
                                        onClick={() => {
                                            setIsEditing(false)
                                            if(onCancel){
                                                onCancel()
                                            }
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button variant="outline" type="submit" onClick={() => onSave(form.getValues())}>
                                        Save
                                    </Button>
                                </div>
                            ) : (
                                <div>
                                    <Button type="button" variant="outline"
                                            onClick={() => setIsEditing(true)}>
                                        Edit
                                    </Button>
                                </div>
                            )}
                        </div>


                    }
                </CardTitle>
            </CardHeader>
            <CardContent>
                <div className="columns-2">
                    <FormField
                        control={form.control}
                        name="title"
                        render={({field}) => (
                            <FormItem>
                                <FormLabel>Title</FormLabel>
                                <FormControl>
                                    <Input
                                        placeholder=""
                                        {...field}
                                        value={field.value}
                                        className="text-lg disabled:cursor-allowed disabled:opacity-100 disabled:border-none"
                                        disabled={!isEditing}
                                        onChange={(e) => {
                                            field.onChange(e.target.value);
                                        }}
                                    />
                                </FormControl>
                                <FormDescription></FormDescription>
                                <FormMessage/>
                            </FormItem>
                        )}
                    />
                    <FormField
                        control={form.control}
                        name="description"
                        render={({field}) => (
                            <FormItem>
                                <FormLabel>Description</FormLabel>
                                <FormControl>
                                    <Input
                                        placeholder=""
                                        {...field}
                                        value={field.value}
                                        className="text-lg disabled:cursor-allowed disabled:opacity-100 disabled:border-none"
                                        disabled={!isEditing}
                                        onChange={(e) => {
                                            field.onChange(e.target.value);
                                        }}
                                    />
                                </FormControl>
                                <FormDescription></FormDescription>
                                <FormMessage/>
                            </FormItem>
                        )}
                    />
                </div>
            </CardContent>
        </form>
    </Form>

}